module.exports = __webpack_public_path__ + "017c8b3b.svg";